import timeslot from '../utils/timeslot';
import { helper } from '@ember/component/helper';

export default helper(timeslot);
